import { render, staticRenderFns } from "./ListaConvenioNacional.vue?vue&type=template&id=59d3e12c&scoped=true"
import script from "./ListaConvenioNacional.vue?vue&type=script&lang=js"
export * from "./ListaConvenioNacional.vue?vue&type=script&lang=js"
import style0 from "./ListaConvenioNacional.vue?vue&type=style&index=0&id=59d3e12c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d3e12c",
  null
  
)

export default component.exports